var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasSpecialNavBar)?_c('special-nav-bar-layout'):_c('normal-layout')}
var staticRenderFns = []

export { render, staticRenderFns }